var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.firstAmmount)+" \n    "),_c('strong',{staticClass:"red-text"},[_vm._v("\n      / \n    ")]),_vm._v("\n    "+_vm._s(_vm.secondAmmount)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Reports/BudgetReport/DoubleColumns.vue